import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { trackEvent } from '../../utils/analytics';
import Spinner from '../ui/Spinner/Spinner';
import SuccessPage from './SuccessPage';
import styles from './PaymentResultPage.module.scss';

const PaymentResultPage = () => {
  const { order_id } = useParams();
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let interval;
    let timeout;

    const checkPaymentStatus = async () => {
      try {
        const response = await fetch(`/api/quiz/payment-status/${order_id}`);
        if (!response.ok) {
          throw new Error('Failed to get payment status.');
        }
        const data = await response.json();
        if (data.status !== 'pending') {
          if (data.status === 'success') {
            trackEvent('purchase', { 
              transaction_id: order_id,
              value: data.amount || 0,
              currency: 'UAH',
              items: [
                {
                  item_id: data.packageType,
                  item_name: data.packageType,
                  price: data.amount || 0
                }
              ]
            });
          } else {
            trackEvent('payment_failure', { order_id, status: data.status });
          }
          setPaymentStatus(data.status);
          setIsLoading(false);
          clearInterval(interval);
          clearTimeout(timeout);
        }
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
        clearInterval(interval);
        clearTimeout(timeout);
      }
    };

    checkPaymentStatus();
    interval = setInterval(checkPaymentStatus, 2000);

    timeout = setTimeout(() => {
      clearInterval(interval);
      if (isLoading) {
        setPaymentStatus('failure');
        setIsLoading(false);
      }
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [order_id, isLoading]);

  if (isLoading) {
    return (
      <div className={styles.container}>
        <Spinner />
      </div>
    );
  }

  if (error) {
    return <SuccessPage title="Помилка" subtitle={error} />;
  }

  if (paymentStatus === 'success') {
    return <SuccessPage title="Дякуємо за оплату!" subtitle="Ваша заявка вже в роботі, ми незабаром з Вами зв’яжемось" />;
  } else {
    return <SuccessPage title="Неуспішна оплата" subtitle="Не хвилюйтесь, ваша заявка вже в роботі, ми зв'яжемось з вами і допоможемо з усіма питаннями" />;
  }
};

export default PaymentResultPage;
